@if (data?.title) {
  <h2 matDialogTitle class="mb-2">{{ data.title }}</h2>
}

<mat-dialog-content>
  @if(errors.length){
    @if (errors.length) {
      <div>
        <ul>
          @for (error of errors; track error) {
            <li class="text-danger">{{error}}</li>
          }
        </ul>
      </div>
    } @else {
      <ng-template [ngTemplateOutlet]="contentXX"></ng-template>
    }
  } @else{
    <div [innerHTML]="content | safeHtml"></div>
  }
</mat-dialog-content>

<mat-dialog-actions class="p-2">
  <button mat-button color="primary" [mat-dialog-close]="false">{{confirm}}</button>
</mat-dialog-actions>
